import { useSetting } from "@/features/settings/hooks/useSetting"

/**
 * Tag color map — maps tag names to CSS color values.
 *
 * Stored as a single synced setting `#tag-colors` (JSON object).
 * Renders as chip background color; falls back to `bg-secondary` if unset.
 *
 * @example
 * const { tagColors, setTagColor } = useTagColors()
 * const color = tagColors["work"] // "#4c8bf5" or undefined
 */
export function useTagColors() {
  const { value: tagColors, setValue: setRawValue } = useSetting<
    Record<string, string>
  >("#tag-colors", {})

  /** Set or clear the color for a specific tag */
  const setTagColor = async (tag: string, color: string | null) => {
    const next = { ...tagColors }
    if (color) {
      next[tag] = color
    } else {
      delete next[tag]
    }
    await setRawValue(next)
  }

  return { tagColors, setTagColor }
}
